import React, { useState } from 'react';
import { auth } from '../services/firebaseConfig'; // adjust path as needed
import { signInWithEmailAndPassword, signOut } from "firebase/auth";
import { useNavigate } from 'react-router-dom';
import Footer from "./Footer";
import { Helmet } from "react-helmet";


<Helmet>
  <title>Admin Login | Kora Insurance </title>
  <meta name="description" content="Protect your family with Kora's flexible and affordable insurance plans. Sign up in minutes and stay covered." />
  <meta name="keywords" content="Insurance Ghana, Family Insurance, Affordable Cover, Kora Insurance" />
  <meta name="robots" content="noindex, nofollow" />
  <link rel="canonical" href="https://korame.com.gh"/>
  {/* Open Graph tags */}
  <meta property="og:title" content="Best Online Insurance Platform" />
  <meta property="og:description" content="Compare and buy insurance plans with ease." />
  <meta property="og:url" content="https://korame.com.gh/" />
  <meta property="og:type" content="website" />
</Helmet>

// Hardcoded allowlist - Replace with your actual admin emails
const adminAllowlist = [
  "yaw.srr@gmail.com",
  "admin2@example.com",
  "nankwasi999@gmail.com"
];

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const userEmail = userCredential.user.email;
      if (adminAllowlist.includes(userEmail)) {
        // Authorized admin
        navigate('/admin_dashboard');
      } else {
        // Not authorized
        await signOut(auth);
        setError('You are not authorized to access this page.');
      }
    } catch (err) {
      console.error(err);
      setError('Login failed. Please check your credentials.');
    }
  };

  return (
    <>
      
      <div style={{ backgroundColor: "#fff", minHeight: "100vh", paddingTop: "6rem", paddingBottom: "3rem"}}>
        <div style={{ maxWidth:'400px', margin:'0 auto', padding:'2rem', background:'#f9fafb', borderRadius:'0.5rem', boxShadow:'0 2px 8px rgba(0,0,0,0.05)' }}>
          <h2 style={{ textAlign:'center', marginBottom:'1.5rem', color:'#2d3748', fontWeight:'600' }}>Admin Login</h2>
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom:'1rem' }}>
              <label style={{ display:'block', marginBottom:'0.5rem', color:'#4a5568' }}>Email</label>
              <input 
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                style={{ 
                  width:'100%', padding:'0.75rem', borderRadius:'0.25rem', border:'1px solid #e2e8f0' 
                }}
              />
            </div>
            <div style={{ marginBottom:'1rem' }}>
              <label style={{ display:'block', marginBottom:'0.5rem', color:'#4a5568' }}>Password</label>
              <input 
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
                style={{
                  width:'100%', padding:'0.75rem', borderRadius:'0.25rem', border:'1px solid #e2e8f0'
                }}
              />
            </div>
            {error && <p style={{ color:'red', marginBottom:'1rem' }}>{error}</p>}
            <button type="submit" style={{
              width:'100%', padding:'0.75rem',
              background:'#2d3748', color:'#fff',
              borderRadius:'0.25rem', border:'none',
              fontWeight:'600', cursor:'pointer'
            }}>Login</button>
          </form>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default AdminLogin;
